import React, { useState } from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsEye, BsThreeDots } from "react-icons/bs";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { FiliacaoEditar } from "../Editar";
import { normalizeString } from "../../../../utils/masks";

export const FiliacaoTableVisualizacao = ({
  data,
  columns,
  updateFiliacoes,
  dataNascimentoCA,
  idCrianca,
  disableHeaderOptions,
  idPJ,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selectedFiliacao, setSelectedFiliacao] = useState();
  const [isVisualizacao, setIsVisualizacao] = useState(false);
  const [vinculoBlocked] = useState(true);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    //gotoPage,
    page,
    //setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: [
          {
            id: "tipoFiliacao",
            desc: false,
          },
        ],
        pageSize: 4,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      if (!disableHeaderOptions) {
        hooks.visibleColumns.push((columns) => [
          ...columns,
          {
            id: "moreInfo",
            Header: "Opções",
            Cell: ({ row }) => (
              <Flex justifyContent="center">
                {row.original.nome !== "Desconhecido" &&
                  row.original.nome !== "Desconhecida" &&
                  normalizeString(row.original.nome) !==
                    normalizeString("Sem informação") && (
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<BsThreeDots color="#fff" fontSize="20px" />}
                        variant={"link"}
                        cursor={"pointer"}
                        backgroundColor="#95BCBF"
                        rounded={100}
                        p={2}
                      />
                      <MenuList>
                        <MenuItem
                          p={2}
                          color={"#374BCE"}
                          onClick={() => {
                            setIsVisualizacao(true);
                            setSelectedFiliacao(row.original);
                            onOpen();
                          }}
                        >
                          <BsEye />
                          <Text ml="5px">Visualizar</Text>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )}
              </Flex>
            ),
          },
        ]);
      }
    }
  );

  // function irParaPagina(pagina) {
  //   gotoPage(pagina);
  // }

  // function selecionarTotalItens(nItens) {
  //   setPageSize(nItens);
  // }

  return (
    <Flex flexDir="column" overflowX="auto">
      <Table {...getTableProps} backgroundColor="white" mt="5px">
        <Thead backgroundColor="#ECEFF1">
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps({
                    ...column.getHeaderProps(
                      !(
                        column.Header === "Opções" ||
                        column.Header === "Termo de Voluntariado"
                      ) && column.getSortByToggleProps({ title: undefined })
                    ),
                  })}
                  w={
                    column.Header === "Opções"
                      ? "10%"
                      : "" || column.Header === "Vínculo"
                      ? "10%"
                      : "" || column.Header === "Nome"
                      ? "23%"
                      : "" || column.Header === "CPF"
                      ? "17%"
                      : "" || column.Header === "Endereço"
                      ? "30%"
                      : "" || column.Header === "Observações"
                      ? "10%"
                      : ""
                  }
                  key={index}
                >
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent={
                      column.Header === "Opções" ||
                      column.Header === "Termo de Voluntariado"
                        ? "center"
                        : "flex-start"
                    }
                  >
                    <Text as="p">{column.render("Header")}</Text>

                    {column.Header !== "Opções" &&
                    column.Header !== "Termo de Voluntariado" ? (
                      <Flex pl={1} alignItems="center">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Icon as={FaSortDown} boxSize="14px" />
                          ) : (
                            <Icon as={FaSortUp} boxSize="14px" />
                          )
                        ) : (
                          <Icon as={FaSort} boxSize="14px" />
                        )}
                      </Flex>
                    ) : (
                      ""
                    )}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <Td
                      key={index}
                      {...cell.getCellProps()}
                      py="6px"
                      fontWeight={500}
                      fontSize="14px"
                      lineHeight="21.6px"
                      color="#797A80"
                    >
                      {cell.render("Cell")}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      {selectedFiliacao && (
        <FiliacaoEditar
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={() => {
            setSelectedFiliacao(null);
            updateFiliacoes();
            onClose();
          }}
          filiacoes={data}
          updateFromVisualizacao={true}
          dataNascimentoCA={dataNascimentoCA}
          selectedFiliacao={selectedFiliacao}
          idCrianca={idCrianca}
          idPJ={idPJ}
          isVisualizacao={isVisualizacao}
          vinculoBlocked={vinculoBlocked}
        />
      )}
    </Flex>
  );
};
